<template>
  <v-app-bar color="primary" dark fixed app>
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="showNavigation(true)"
    />
    <v-toolbar-title>
      MyRxAssist Admin Portal
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items
      v-for="item in navItems"
      :key="item.text"
      class="hidden-sm-and-down"
    >
      <v-btn
        :to="item.link"
        text
      >
        <v-icon>
          {{ item.icon }}
        </v-icon>
        {{ item.text }}
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon dark v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="setShowUploadModal(true)">
            <v-list-item-action>
              <v-icon color="primary">import_export</v-icon>
            </v-list-item-action>
            <v-list-item-content>Upload Initiative</v-list-item-content>
          </v-list-item>
          <v-list-item @click="refreshClientCache">
            <v-list-item-action>
              <v-icon color="primary">cached</v-icon>
            </v-list-item-action>
            <v-list-item-content>Refresh Client Cache</v-list-item-content>
          </v-list-item>
          <v-list-item @click="refreshFeatureCache">
            <v-list-item-action>
              <v-icon color="primary">refresh</v-icon>
            </v-list-item-action>
            <v-list-item-content>Refresh Feature Cache</v-list-item-content>
          </v-list-item>
          <v-list-item @click="disconnectDatabase">
            <v-list-item-action>
              <v-icon color="primary">cancel_presentation</v-icon>
            </v-list-item-action>
            <v-list-item-content>Disconnect from Databases</v-list-item-content>
          </v-list-item>
          <v-list-item @click="doLogout">
            <v-list-item-action>
              <v-icon color="primary">power_settings_new</v-icon>
            </v-list-item-action>
            <v-list-item-content>Logout</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  name: 'the-navigation-bar',
  props: {
    navItems: Array
  },
  computed: {
    ...mapState('adminSettings', ['showLogoutModal', 'showUploadModal'])
  },
  methods: {
    ...mapMutations({
      showNavigation: 'navbar/setShowMobileNav'
    }),
    ...mapActions('adminSettings', ['refreshClientCache', 'refreshFeatureCache', 'disconnectDatabase', 'logout']),
    ...mapMutations('adminSettings', ['setShowUploadModal', 'setShowLogoutModal']),
    doLogout() {
      this.logout().then(e => this.setShowLogoutModal(e), () => {})
    }
  }
}
</script>
